import { render, staticRenderFns } from "./sendRemainder.vue?vue&type=template&id=9f09a2b2&"
import script from "./sendRemainder.vue?vue&type=script&lang=js&"
export * from "./sendRemainder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports